import React from 'react';

import { SidebarFiltersSection } from 'components/sidebar-filters';
import { CheckboxGroup } from 'components/core';

import { useSpecialsFilter } from './use-specials-filter';

export function SpecialsFilter(): JSX.Element {
  const { options, selectedFilters, handleSelection, heading } = useSpecialsFilter();

  return (
    <SidebarFiltersSection startsOpen heading={heading}>
      <CheckboxGroup options={options} selectedOptions={selectedFilters} onSelect={handleSelection} />
    </SidebarFiltersSection>
  );
}
